var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"relatorios-personalizados"},[_c('hal-gerador-relatorios',{attrs:{"formato-lista":"Lista","produto-id":"150"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }